/* Actions */
import { SET_IS_OPEN } from "./actions";

const isModalSelectorOpen = (state = false, { type, payload }) => {
  switch (type) {
    case SET_IS_OPEN:
      return payload;
    default:
      return state;
  }
};

export default isModalSelectorOpen;
